import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireStorage } from 'angularfire2/storage';
@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.css']
})
export class UnderConstructionComponent implements OnInit {

  private banner: Observable<string | null>;

  constructor(private storage: AngularFireStorage) { }

  ngOnInit() {
    this.banner = this.storage.ref('/public/underConstructionBanner.jpeg').getDownloadURL();
  }

}



// WEBPACK FOOTER //
// ./src/app/under-construction/under-construction.component.ts